import { CompanyLogin } from "./companyLogin";
import { UserGroup } from "./userGroup";
import { UserCompanyGroupDto } from "./userCompanyGroupDto";

export class UserCompanyGroup {

    constructor(userCompanyGroupDto: UserCompanyGroupDto | null) {
        if(userCompanyGroupDto) {
            this.id = userCompanyGroupDto.id;
            this.userid = userCompanyGroupDto.userid;
            this.companyLoginId = userCompanyGroupDto.companyLoginId;
            this.userGroupId = userCompanyGroupDto.userGroupId;
            this.platformProfileId = userCompanyGroupDto.platformProfileId;
            this.companyLogin = userCompanyGroupDto.companyLogin;
            this.userGroup = new UserGroup(userCompanyGroupDto.userGroup);
        }
    }

    id: number;
    userid: string;
    companyLoginId: string;
    userGroupId: number;
    platformProfileId: number;
    companyLogin: CompanyLogin;
    userGroup: UserGroup;
}